import gql from 'graphql-tag';

const GET_USER_WALLETS = gql`
    query getWalletsByUserId {
        getWalletsByUserId {
            id,
            address,
            blockchain,
            verified,
            isKycVerified,
        }
    }
`

const GET_ALL_USER_WALLETS = gql`
    query getAllWalletsByUserId {
        getAllWalletsByUserId {
            id,
            address,
            blockchain
        }
    }`

const GET_USER_WALLET = gql`
    query getWalletByUserId {
        getWalletByUserId {
            id,
            address,
            verified,
            isKycVerified,
        }
    }
`

export { GET_USER_WALLETS, GET_USER_WALLET, GET_ALL_USER_WALLETS };